'use strict';

$(document).ready(function () {
    let urlParams = new URLSearchParams(window.location.search);
    let red = urlParams.get('redirect');
    let useSafeLogin = urlParams.get('enableSecurityRedirect');
    let loginUserName = urlParams.get('username');
    let nextPageUrl = urlParams.get('nextRedUrl');

    if (useSafeLogin) {
      var url = window.location.href;
      window.sessionStorage.setItem("loginUserName", loginUserName)
      window.sessionStorage.setItem("enableSecurityRedirect", true)

      if (url.indexOf("?") != -1) {
        url = url.replace(/(\?|#)[^'"]*/, '');
        window.history.pushState({},0,url);
      }

      $(".login").attr("style", "background-color: aliceblue");
      $(".login-logo").attr("style", "display:none");
      $(".login-block").attr("style", "margin-top: 100px;");
      $("#login-reg-link").attr("style", "display:none");
      $("#reset-link").attr("style", "display:none");
      $("#login-site-title").removeAttr("class", "hide");
      $("#username").val(loginUserName);
      $("#useSafeLogin").val(true);
      $("#safeLoginNextPage").val(nextPageUrl);
      window.sessionStorage.removeItem("enableSecurityRedirect");
      window.sessionStorage.removeItem("loginUserName");

      return;
    }

    if (red) {
        window.location.href = config.altai_login_redirect + red;
    }
});
